import Connector from './../api/connector';

/**
 * Datalayer
 *
 * @module datalayer
 */
 const component = {

    /**
     * Init component
     * 
     * @returns {undefined}
     */
    init: () => {

        /**
         * Datalayer module api
         * 
         * @global
         */
        window.theme.datalayer = component;
    },

    getProduct: (identifier) => {

        return new Promise((resolve, reject) => {
            
            Connector.getProduct(identifier).then(productData => {
                resolve(productData);
            });
        });
    },

    getCart: () => {

        return new Promise((resolve, reject) => {
            
            Connector.getCart().then(cartData => {
                resolve(cartData);
            });
        });
    },

    addToCart: (id, qty, properties, formData) => {

        return new Promise((resolve, reject) => {
            
            Connector.addToCart(id, qty, properties, formData).then(result => {
                resolve(result);
            }).catch(function(error) {
                reject(error);
            });
        });
    },

    removeItemFromCart: (id) => {

        return new Promise((resolve, reject) => {
            
            Connector.updateItemFromCart(id, 0, null).then(result => {
                resolve(result);
            });
        });
    },

    updateItemFromCart: (id, qty, properties) => {

        return new Promise((resolve, reject) => {
            
            Connector.updateItemFromCart(id, qty, properties).then(result => {
                resolve(result);
            }).catch(function(error) {
                reject(error);
            });
        });
    },
    
};

export default component;
